import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { RootState } from "@/redux/reducers";
import { ClusterState } from "@/components/PageCluster/redux/types";
import { ClusterApiResponse } from "@/components/PageCluster/api/interface";

const selectCluster = (state: RootState): ClusterState => state?.cluster;

export default createDraftSafeSelector(
  selectCluster,
  (cluster: ClusterState): ClusterApiResponse => cluster.clusterData
);
